import { initDesign, handlePropsChange } from 'public/Design/design';

$w.onReady(async function () {
    await initDesign();
});

$widget.onPropsChanged(async (oldProps, newProps) => {
    await handlePropsChange(newProps);
});